export { default as SubCategoryPage } from "./View";
export { default as PageSubCategory } from "./Page";